import { Text } from '@chakra-ui/react';

export function Logo() {
  return (
    <Text
      fontSize={['xl', '2xl', '3xl']}
      fontWeight="semibold"
      letterSpacing="tight"
      w="64"
      color="white"
    >
      Painel
      <Text as="span" ml="1" color="yellow.400">
        Parceiros
      </Text>
    </Text>
  );
}
